function t() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}

function i() {
  return /Android/gi.test(window.navigator.userAgent);
}

function n() {
  return t() || i();
}

export { i as isAndroid, t as isIOS, n as isMobile };